// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__5XvhQ","checkbox":"TodoItem_checkbox__VIseF","textInput":"TodoItem_textInput__8Us3L"};